import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CacheStorageService } from "./cache-storage";
import { PreciseDateDurationPipe, PreciseDatePipe, PreciseDateUnixPipe } from "./date-util/pipes";
import { StringCapitalizePipe } from "./date-util/pipes/string-capitalize.pipe";

// Set DayJS globally
import Dayjs from "dayjs";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";

Dayjs.extend(duration);
Dayjs.extend(localeData);
Dayjs.extend(localizedFormat);
Dayjs.extend(customParseFormat);

Dayjs.locale("fr");

@NgModule({
	imports: [CommonModule, PreciseDateUnixPipe],
	declarations: [PreciseDateDurationPipe, PreciseDatePipe, StringCapitalizePipe],
	exports: [PreciseDateDurationPipe, PreciseDatePipe, PreciseDateUnixPipe, StringCapitalizePipe],
	providers: [CacheStorageService],
})
export class UtilsModule {}
